import DatePicker, { type DatePickerProps } from './date-picker';

export { DatePickerProps };

export default DatePicker;
